import { createSlice } from '@reduxjs/toolkit';

import { thunks } from './thunks';
import { selectors } from './selectors';
import { status } from '../../utils/const';

const initialState = {
  dancersList: {},

  loadingListStatus: status.IDLE,
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(thunks.getPieChatData.pending, (state) => {
        state.loadingListStatus = status.PENDING;
      })
      .addCase(thunks.getPieChatData.fulfilled, (state, action) => {
        state.dancersList = action.payload;
        state.loadingListStatus = status.SUCCESS;
      })
      .addCase(thunks.getPieChatData.rejected, (state) => {
        state.loadingListStatus = status.FAIL;
      });
  },
});

const dashboard = {
  actions: slice.actions,
  thunks,
  selectors,
};

export { dashboard };
export default slice.reducer;
